import React, { useEffect, useState } from "react";
import { colourStyles } from "../Utils/styled-components/react-select.style";
import { useForm } from "react-hook-form";
import { Message } from "@material-ui/icons";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getRequest, postRequest } from "../Services/axios.service";
import ReactTooltip from "react-tooltip";
import { normalizePhone } from "../Utils/normalize";
import {
  CLIENT,
  Reclamation
} from "../Utils/url.api";
function ReclamacionUsuario() {
 
  const [loadingSet, setLoadingSet] = useState({
    submitLoading: false,
    pageLoading: false,
  });
  const navigate = useNavigate();
  const { register, handleSubmit, formState:{errors}} = useForm({ mode: "onBlur" });



  const onSubmit= async (model) => {
    console.log(model)
    const sendModel = {
      ...model,
      nombre: model.nombre,
      email: model.email,
      reclamacion:model.reclamacion,
      telefono: model.telefono
  };
  setLoadingSet((cur) => ({ ...cur, submitLoading: true }));
    await toast
      .promise(postRequest(Reclamation, sendModel), {
        pending: {
          position: "top-center",
          type: "default",
          isLoading: true,
          icon: false,
          render: () => "Espere",
        },
      })
      .then((res) => {
        console.log("resultasdo:", res)
        setLoadingSet((cur) => ({ ...cur, submitLoading: false }));
        if (res.status === 200 || res.status === 201) {
            setTimeout(() => {
              navigate("/");
            }, 2000);
        } else if (res.data.statusCode === 500) {
          toast(`Ha ocurrido un error, mensaje: ${res.data.message}`, {
            theme: "colored",
            type: "error",
          });
        }
      });
  };



  return (
    <>
     {loadingSet.pageLoading && <div className="flex "><div className="spinner-loading"></div></div>}
     {!loadingSet.pageLoading && (
     <div className="flex w-full h-screen  items-center justify-center text-lg bg-primary">
       <ToastContainer />
      
      <div className="text-left  my-6 bg-white  shadow-md
      rounded px-8 py-6 w-1/2 h-auto">
         <h2 className="text-center text-2xl font-medium text-font-primary">
         Formulario de Reclamaciones
         </h2>
        <form onSubmit={handleSubmit((data) => onSubmit(data))} className="custom-form">
          <div className="custom-form__control">
            <label className="custom-form__label" htmlFor="nombre">
              Nombre completo
            </label>
            <input
              className="custom-form__input"
              id="nombre"
              type="text"
              {...register('nombre',{
               required:{
                value:true,
                message:"El nombre es requerido"
               }
               
              })}
            
            />
            {errors.nombre?.type === "required" && (
                  <p className="text-danger" role="alert">
                    {errors.nombre?.message}
                  </p>
                )}
          </div>
          <br />

          <div className="custom-form__control">
            <label className="custom-form__label" htmlFor="correo">
              Correo
            </label>
            <input
               className="custom-form__input"
               id="email"
               type="email"
             {...register('email',{
              required:{
                value:true,
                message:"el correo es requerido"
              },
              pattern: {
                value:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "Correo invalido",
              },
             },
             )}
           
            />
           {errors.email?.type === "required" && (
                  <p className="text-danger" role="alert">
                    {errors.email?.message}
                  </p>
                )}
                {errors.email?.type === "pattern" && (
                  <p className="text-danger" role="alert">
                    {errors.email?.message}
                  </p>
                )}
          </div>
          <br />

          <div className="custom-form__control">
            <label className="custom-form__label" htmlFor="nombre">
              Telefono
            </label>
            <input
             className="custom-form__input"
             id="telelefono"
             type="text"
              {...register('telefono',{
               required:{
                value:false,
                message:"El telefono es requerido"
               }
               
              })}
             
            />
            {errors.telefono?.type === "required" && (
                  <p className="text-danger" role="alert">
                    {errors.telefono?.message}
                  </p>
                )}
          </div>
          <br />
          <div className="custom-form__control">
            <label className="custom-form__label" htmlFor="reclamacion">
              Reclamación
            </label>
            <textarea
             className="custom-form__input"
             id="reclamacion"
             type="text"
             {...register('reclamacion',{
              required:{
                value:true,
                message:"La reclamacion es requerida"
              }
             })}
              
            />
            {errors.reclamacion?.type ==='required' && (
            <p className="text-danger" role="alert">{errors.reclamacion?.message}</p>)}
          </div>
         
          <br />

          <div>
          <button
            type="submit"
            className="flex justify-center w-full uppercase rounded-[20rem] bg-primary text-xl rounded px-8 py-4 my-4 text-white"
          >
            Enviar reclamación
          </button>
          <button
            type="submit"
            className="flex justify-center w-full uppercase rounded-[20rem] bg-orange-900 text-xl rounded px-8 py-4 my-4 text-white"
            onClick={() =>{navigate('/')}}
          >
            Volver
          </button>
          </div>
         
        </form>
      </div>
    </div>
     )}
    </>
   
  );
}

export default ReclamacionUsuario;
